// extracted by mini-css-extract-plugin
export default {"activeLink":"styles_activeLink__WgUvt","unactiveLink":"styles_unactiveLink__Iyn8m"};